
<template>
  <div
    class="top-bar"
    :style="{ paddingTop: statusBarHeightPX }"
  >
    <div
      class="fixed"
      :style="fixedStyle"
    >
      <template>
        <SvgIcon v-if="isBack" icon-class="arrow" class-name="arrow" @click.native="handleArrow"></SvgIcon>
        <!-- i用来做占位符 -->
        <i v-else></i>
      </template>
      <span class="title">{{title}}</span>
      <template>
        <slot v-if="$slots.rightPosition" name="rightPosition"></slot>
        <i v-else></i>
      </template>
    </div>
  </div>
</template>

<script>
import BridgeMixin from '@/mixins/bridge'
import Bridge from '@/frontend-lib/lib/Bridge'
import SvgIcon from '@/components/SvgIcon'
import { getPlatform } from 'lib/tools/getPlatform'
function getQuery (param) {
  const reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg) || window.location.hash.substring((window.location.hash.search(/\?/)) + 1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
}
export default {
  name: 'TopBar',
  mixins: [BridgeMixin],

  data() {
    return {
      statusBarHeight: 0
    }
  },

  props: {
    title: String,
    arrowFn: Function,
    color: {
      type: String,
      default: '#21252D'
    },
    isBack: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    statusBarHeightPX () {
      return this.statusBarHeight + 'px'
    },
    fixedStyle () {
      return {
        paddingTop: this.statusBarHeightPX,
        '--color': this.color,
        '--statusBarHeight': this.statusBarHeightPX
      }
    }
  },

  components: {
    SvgIcon
  },

  mounted() {
    if (this.mixinIsApp) {
      const hasNotchCallbackName = 'commonMobileHeaderHasNotchCallbackName'
      this.getBridge().call('hasNotch', {
        callbackName: hasNotchCallbackName
      })
      const { isAndroid } = getPlatform()
      new Bridge({
        methods: [
          {
            method: hasNotchCallbackName,
            callback: obj => {
              const { hasNotch, notchHeight } = obj
              this.statusBarHeight =
                notchHeight && window.devicePixelRatio
                  ? (notchHeight / window.devicePixelRatio) | 0
                  : hasNotch === 1 || hasNotch === true
                  ? isAndroid
                    ? 35
                    : 40
                  : 20
              this.$emit('statusBar', this.statusBarHeight)
            }
          }
        ]
      })
    }
  },

  methods: {
    handleArrow () {
      if (typeof this.arrowFn === 'function') {
        this.arrowFn()
      } else {
        this.back()
      }
    },
    back () {
      const currentPage = getQuery('currentPage')
      const backUrl = getQuery('backUrl')
      if (currentPage) {
        window.history.go(-1)
      } else if (backUrl) {
        window.location.replace(decodeURI(backUrl))
      } else {
        new Bridge().call('cancelWebView')
      }
      // if (this.historyLength > 1) {
      //   window.history.go(-1)
      //   // this.$router.back()
      // } else if (isApp()) {
      //   this.getBridge().call('cancelWebView')
      // }
    }
  }
}
</script>
<style lang="scss" scoped>
.top-bar {
  width: 100%;
  height: 88px;
  .fixed {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    max-width: 750px;
    height: calc(var(--statusBarHeight) + 88px);
    z-index: 12;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 36px;
    box-sizing: border-box;
    color: var(--color);
    .arrow {
      transform: rotateZ(180deg);
      font-size: 30px;
    }
    .title {
      font-family: PingFangSC-Medium;
      font-size: 36px;
    }
  }
}
</style>
